export const GET_NEW_FIXED_FEES = 'NEW_FIXED_FEES/get_new_fixed_fees';
export const GET_SINGLE_NEW_FIXED_FEES =
  'NEW_FIXED_FEES/get_single_new_fixed_fees';
export const UPDATE_NEW_FIXED_FEES = 'NEW_FIXED_FEES/update_new_fixed_fees';
export const CREATE_NEW_FIXED_FEES = 'NEW_FIXED_FEES/create_new_fixed_fees';
export const REMOVE_NEW_FIXED_FEES = 'NEW_FIXED_FEES/remove_new_fixed_fees';

export const FORM_DATA = {
  code: '',
  multiplier: '',
  name: '',
  description: '',
  amount: '',
  for_new: '',
  for_renewal: '',
};

export const multiplierOption = [
  { label: 'Area', value: 'area' },
  { label: 'No. of Employees', value: 'no_of_employees' },
  { label: 'No. of Male Employees', value: 'no_of_male_employees' },
  { label: 'No. of Female Employees', value: 'no_of_female_employees' },
  { label: 'No. of Employees Residing in Manila', value: 'no_of_employees_residing_manila' },
  { label: 'No. of Vans', value: 'no_of_van' },
  { label: 'No. of Trucks', value: 'no_of_truck' },
  { label: 'No. of Motorcycles', value: 'no_of_motorcycles' },
  { label: 'No. of Vehicles', value: 'no_of_vehicles' },
  { label: 'Location Owned', value: 'location_owned' },
];
